export type ProjectCustomersFieldTypes =
  | `gps_track`
  | `driver_info`
  | `status_history`
  | `survey`
  | `string`
  | `number`
  | `boolean`
  | `date`
  | `images`
  | `signature`
  | `location`
  | `phone_call`
  | `url`
  | `email`
  | `report_date`
  | `report_time`;

export const projectCustomersAppValues = {
  driver_position: `gps_track`,
  stop_position: `location`,
  status_history: `status_history`,
  stops_left: `number`,
  execution_date: `date`,
  driver_info: `driver_info`,
  planned_arrival_time: `date`,
  estimated_arrival_time: `date`,
  pin: `string`,
  phone_call: `phone_call`,
  additional_info: `string`,
  customer_text_field: `string`,
  survey: `survey`,
  report_date: `date`,
  report_time: `date`,
};

export type ProjectCustomersAppType = keyof typeof projectCustomersAppValues;

export const projectCustomersStopFieldValues = {
  label: `string`,
  location: `location`,
  location_details: `string`,
  external_id: `string`,
  client_external_id: `string`,
  comments: `string`,
  reference_person: `string`,
  phone: `string`,
  url: `url`,
  cluster: `string`,
  email: `email`,
  weight: `number`,
  volume: `number`,
  reward: `number`,
  duration: `number`,
  max_delivery_time: `number`,
};

export type ProjectCustomersStopFieldType = keyof typeof projectCustomersStopFieldValues;

export const projectCustomersStopCompletedValues = {
  images: `images`,
  signature: `signature`,
  location: `location`,
  comments: `string`,
};

export type ProjectCustomersStopCompletedType = keyof typeof projectCustomersStopCompletedValues;

export const projectCustomersStopCanceledValues = {
  comments: `string`,
  cancel_reason: `string`,
  images: `images`,
};

export type ProjectCustomersStopCanceledType = keyof typeof projectCustomersStopCanceledValues;
